import { render, staticRenderFns } from "./Paging.vue?vue&type=template&id=86fb8498&scoped=true"
import script from "./Paging.vue?vue&type=script&lang=ts"
export * from "./Paging.vue?vue&type=script&lang=ts"
import style0 from "./Paging.vue?vue&type=style&index=0&id=86fb8498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../nhaphangtocdo/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fb8498",
  null
  
)

export default component.exports